import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1775546269376'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='11730'
        width='200'
        height='200'
    >
        <path
            d='M684.32 960v-68.928h206.752v-206.752H960V960h-275.68zM64 960v-275.68h68.928v206.752h206.752V960H64z m179.968-327.36A781.504 781.504 0 0 1 132.928 512v-0.192a790.08 790.08 0 0 1 111.04-120.416C306.528 336.256 403.84 270.72 512 270.72c108.16 0 205.44 65.504 268.032 120.64A781.504 781.504 0 0 1 891.072 512v0.192a790.08 790.08 0 0 1-111.04 120.416c-62.592 55.136-159.904 120.64-268.032 120.64-108.16 0-205.44-65.504-268.032-120.64zM339.68 512a172.32 172.32 0 1 0 344.64 0 172.32 172.32 0 0 0-344.64 0z m71.808 0a103.36 103.36 0 0 1 103.36-103.36h1.728a86.144 86.144 0 0 0 101.664 101.632V512a103.36 103.36 0 0 1-206.752 0z m479.584-172.32V132.928h-206.752V64H960v275.68h-68.928zM64 339.68V64h275.68v68.928H132.928v206.752H64z'
            fill='currentColor'
            p-id='11731'
        ></path>
    </svg>
)

export const SaveViewIcon = props => <Icon component={SVG} {...props} />
